<template>
  <div :id="id">
    <div v-if="showResults" class="swk-zoeken-results-list">
      <div class="zoeken" v-if="zoeken">Bezig met zoeken...</div>
      <div class="close-button-wrapper">
        <button
          v-if="results && results.length > 0"
          @click="closeResults"
          class="btn btn-primary close"
        >
          <img :src="`${publicPath}assets/images/close-button.svg`" />
        </button>
      </div>
      <div class="no-results" v-if="noResults">Geen resultaten.</div>
      <div class="results">
        <a
          v-for="(result, index) in results"
          class="result"
          :href="result.link"
          :key="index"
        >
          <span class="title" v-html="result.title.rendered"></span>
          <span
            class="type"
            v-html="result.type"
            v-if="result.type == 'locatie' || result.type == 'school'"
          ></span>
          <span class="excerpt" v-html="result.excerpt.rendered"></span>
        </a>
      </div>

      <div
        class="swk-pagination"
        v-if="results && results.length > 0 && totalPages > 1"
      >
        <paginate
          v-model="page"
          :page-count="totalPages"
          :prev-text="'Vorige'"
          :next-text="'Volgende'"
          :page-range="3"
          :margin-pages="2"
          :click-handler="paginationClick"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Paginate from "vuejs-paginate";
import VueScrollTo from "vue-scrollto";

export default {
  components: {
    Paginate,
  },

  props: {
    id: {
      type: String,
    },
    prop_posts_per_page: {
      type: Number,
      required: false,
      default: 10,
    },
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      results: [],
      noResults: false,
      zoeken: false,
      showResults: false,
      errors: [],
      totalPages: 10,
      page: 1,
    };
  },

  computed: {
    termSearch: {
      get() {
        return this.$store.state.termSearch;
      },
      set(value) {
        this.$store.commit("updateTermSearch", value);
      },
    },
    term: {
      get() {
        return this.$store.state.term;
      },
      set(value) {
        this.$store.commit("updateTerm", value);
      },
    },
    clickedSearchButton: {
      get() {
        return this.$store.state.clickedSearchButton;
      },
    },
  },

  watch: {
    termSearch(value, oldvalue) {
      if (value != oldvalue) {
        this.page = 1;
        this.search();
      }
    },
    clickedSearchButton() {
      this.search();
    },
  },

  methods: {
    closeResults() {
      this.showResults = false;
    },

    search() {
      this.zoeken = true;
      this.showResults = true;
      this.results = [];

      // Get height of all sticky elements (headers)
      let elems = document.body.getElementsByTagName("*");
      let topHeight = 0;

      for (var i = 0; i < elems.length; i++) {
        if (
          window
            .getComputedStyle(elems[i], null)
            .getPropertyValue("position") == "sticky"
        ) {
          //console.log(elems[i].offsetHeight);
          topHeight = topHeight - elems[i].offsetHeight;
        }
      }

      VueScrollTo.scrollTo(
        "#swk-zoeken-results-" + this.id.split("-").pop(),
        1000,
        {
          offset: topHeight,
          lazy: true,
          force: false,
        }
      );

      // Test URL?
      //let base_url = "https://www.kov-bijdehand.nl/";
      let base_url = "";

      // Live URL
      let url =
        base_url +
        "/wp-json/wp/v2/posts?search=" +
        this.term +
        "&type[]=page&orderby=relevance&order=asc&page=" +
        this.page +
        "&per_page=" +
        this.prop_posts_per_page;
      axios
        .get(url)

        .then((response) => {
          this.results = response.data;
          this.zoeken = false;
          this.noResults = this.results.length === 0;
          this.totalPages = parseInt(response.headers["x-wp-totalpages"]);
          this.activeIndex = null;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    paginationClick(pageClicked) {
      this.page = pageClicked;
      this.activeId = null;
      this.search();
    },
  },
};
</script>

<style lang="scss">
.zoeken {
  padding: 0.5rem;
}

.swk-zoeken-results,
.swk-zoeken-results-list {
  display: flex;
  flex-flow: row wrap;
  max-width: 992px;
  margin-top: 1rem;
  margin: 0 auto;
}

.swk-zoeken-form {
  flex: 1;
}

.swk-zoeken-results-list {
  padding: 1rem;
  background-color: #fff;

  .close-button-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  button.close {
    display: flex;
    border: none;
    background-color: transparent;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 1.75rem;
      height: 1.75rem;
    }
  }

  a {
    text-decoration: none;
  }

  .result {
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 5px;
    padding: 0.5rem;

    p {
      margin: 0;
    }
  }

  .title {
    font-size: 1.15rem;
  }
  .type {
    color: #aaa;
    margin-left: 0.5rem;
  }

  .excerpt {
    width: 100%;
    color: #888;
  }

  .result:hover {
    text-decoration: none;
    background-color: #eee;
  }

  .swk-pagination {
    margin-top: 1rem;
  }

  .swk-pagination ul li {
    display: inline-block;
  }

  .swk-pagination ul li a:hover {
    background-color: #aaa;
  }

  .swk-pagination ul li.active a {
    display: inline-block;
    background-color: #888;
  }

  .swk-pagination ul li.disabled a {
    display: inline-block;
    background-color: #fff;
    color: #ccc;
  }

  .swk-pagination ul li:first-child a {
    margin-left: 0;
  }

  .swk-pagination ul li a {
    background-color: #eee;
    padding: 1rem;
    margin-left: 0.5rem;
    display: inline-block;
  }
}
</style>
